import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";

const Permission = () => {
  // const API_BASE_URL = "http://localhost:8000/api";

  const mainMenus = [
    { id: 1, menu_name: "HR Management" },
    { id: 2, menu_name: "Incharge Management" },
    { id: 6, menu_name: "Dept Management" },
  ];

  const jobStatuses = [
    "Applied", "Shortlisted", "Interview", "Recruitment", "Hold", "Rejected", "Joined"
  ];

  const [checked, setChecked] = useState({});
  const [expandedMenus, setExpandedMenus] = useState({});
  const [loading, setLoading] = useState(true);

  const handleToggle = (key) => {
    setChecked((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const isAllChecked = (roleId) => {
    return jobStatuses.every((status) => checked[`${roleId}_${status}`]);
  };

  const handleSelectAll = (roleId) => {
    const allChecked = isAllChecked(roleId);
    const updated = { ...checked };
    jobStatuses.forEach((status) => {
      updated[`${roleId}_${status}`] = !allChecked;
    });
    setChecked(updated);
  };

  const toggleExpand = (menuId) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menuId]: !prev[menuId],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedPermissions = Object.entries(checked)
      .filter(([_, isChecked]) => isChecked)
      .map(([key]) => {
        const [role_id, field_name] = key.split("_");
        return { role_id: Number(role_id), field_name };
      });

    const allRoleIds = mainMenus.map(menu => menu.id); // Send all visible roles

    try {
      await axios.post(`${API_BASE_URL}/save-job-permission`, {
        permissions: selectedPermissions,
        all_roles: allRoleIds
      });

      toast.success("Permissions saved successfully!");
    } catch (err) {
      console.error("Error saving:", err);
      toast.error("Failed to save permissions.");
    }
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/job-permissions`)
      .then((res) => {
        const savedPermissions = res.data; // [{ role_id, field_name }]
        const newChecked = {};

        savedPermissions.forEach((perm) => {
          const key = `${perm.role_id}_${perm.field_name}`;
          newChecked[key] = true;
        });

        setChecked(newChecked);
      })
      .catch((err) => {
        console.error("Error fetching permissions:", err);
        toast.error("Failed to load permissions.");
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="container py-4">
      <h4 className="mb-4">Assign Permissions</h4>
      <ToastContainer />

      {loading ? (
        <p>Loading...</p>
      ) : (
        <form onSubmit={handleSubmit}>
          {mainMenus.map((menu) => (
            <div key={menu.id} className="card shadow mb-4">
              <div
                className="card-header d-flex justify-content-between align-items-center"
                onClick={() => toggleExpand(menu.id)}
                style={{ cursor: "pointer" }}
              >
                <h5 className="mb-0">{menu.menu_name}</h5>
                <span className="text-muted">
                  {expandedMenus[menu.id] ? "−" : "+"}
                </span>
              </div>

              {expandedMenus[menu.id] && (
                <div className="card-body p-0">
                  <table className="table table-bordered mb-0">
                    <thead className="bg-light">
                      <tr>
                        <th style={{ width: "80%" }}>Job Status</th>
                        <th className="text-center" style={{ width: "20%" }}>
                          <input
                            type="checkbox"
                            checked={isAllChecked(menu.id)}
                            onChange={() => handleSelectAll(menu.id)}
                          />{" "}
                          Enable All
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {jobStatuses.map((status) => {
                        const key = `${menu.id}_${status}`;
                        return (
                          <tr key={key}>
                            <td>{status}</td>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                checked={checked[key] || false}
                                onChange={() => handleToggle(key)}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ))}

          <button className="btn btn-primary mt-3" type="submit">
            Submit Selected
          </button>
        </form>
      )}
    </div>
  );
};

export default Permission;